import { MutationTree } from 'vuex';
import { State } from './tokenManager.store';

const mutations: MutationTree<State> = {
    setTokenList(state: State, data: any) {
        state.tokenList = data;
      },
      setPrevRoute(state: State, data:any) {
        state.prevRoute = data;
    },
    setIsGlobalTokenActive(state: State, data:any) {
        state.isGlobalTokenActive = data;
    },
    setSearchTokenName(state: State, data:any) {
        state.searchTokenName = data;
    },
    setAllMappedTokensDeleted(state: State, data:any) {
        state.allMappedTokensDeleted = data;
    },
    setTokenId(state: State, data:any) {
        state.tokenId = data;
    },
    setTokenName(state: State, data:any) {
        state.tokenName = data;
    },
    setIsTokenDeleteActive(state: State, data:any) {
        state.isTokenDeleteActive = data;
    },
    setTokenPageNum(state: State, data:any) {
        state.tokenPageNum = data;
    },
    setTokenSortParams(state: State, data:any) {
        state.tokenSortParams = {...data};
    },
    setDefaultValues(state: State, data:any) {
        state.allMappedTokensDeleted = false;
        state.isGlobalTokenActive = true;
        state.isTokenDeleteActive = false;
        state.searchTokenName = '';
        state.tokenId = '';
        state.tokenList = [];
        state.tokenName = '';
    },
    setIsTokenFormOpen(state: State, data: any) {
        state.isTokenFormOpen = data;
    },
    setTokenFormData(state: State, data: any) {
        state.tokenFormData = {
            ...state.tokenFormData,
            ...data
        }
    }
}

export default mutations;